/**
 * Compact track card for the recent strip and the archive grid.
 * Links to the detail page. Shows thumbnail, title, and artist.
 */

import { Link } from 'react-router-dom';


export default function TrackTile({ track }) {
  return (
    <Link to={`/tracks/${track.id}`} className="tt-tile">
      <div className="tt-tile__thumb">
        {track.thumbnail_url ? (
          <img src={track.thumbnail_url} alt="" loading="lazy" />
        ) : (
          <div className="tt-tile__thumb-fallback">▶</div>
        )}
        <div className="tt-tile__play" aria-hidden="true">▶</div>
      </div>
      <div className="tt-tile__meta">
        <h4 className="tt-tile__title">{track.title}</h4>
        <p className="tt-tile__artist">{track.artist}</p>
      </div>
    </Link>
  );
}
